var spoiler_default = {
  "fontElementMap": "RbQIG",
  "hideText": "yrSsX",
  "onHoverText": "BjvhV",
  "hideBlock": "j7CvO",
  "smallBlur": "y-hhA",
  "mediumBlur": "_8qy8Y",
  "largeBlur": "NEl5B",
  "hideBlock_gallery": "Ag51c",
  "overlay": "_9Wbra",
  "overlay_gallery": "Xl3pv",
  "revealSpoilerBtn": "MF97M",
  "isMobile": "vNZcU",
  "onHoverBtn": "fsfoI",
  "spoilerWrapper": "uEmz1",
  "spoilerDescription": "f30u4",
  "spoilerContainer": "CWMiS",
  "spoilerContainer_Gallery": "FjXAL"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
